import { SelectOption } from '@doveit/bricks';
import { asSelectOptions } from './utils/asSelectOptions';
import { rumorStatusLabels } from '../rumor/constants';

const { KO_NOT_INTERESTED, KO_NOT_CONFIRMED } = rumorStatusLabels;

export const rumorKOStatusSelectOptions: SelectOption[] = asSelectOptions({ KO_NOT_INTERESTED, KO_NOT_CONFIRMED });
